import { atom } from 'jotai';
import { useMemo } from 'react';
import searchAtomPair, { SearchParams } from 'atoms/search-atom';
import type { ActivityFeedItem } from './types';

export const isActivityFeedPanelOpenAtom = atom<boolean>(false);

export interface ActivityFeedSearchParams extends SearchParams {
  modelType: string;
  modelId?: number;
}

/**
 * Builds a memoized search-atom pair for the activity feed query, scoped by
 * model type and optional model id. Omit `modelId` to fetch the cross-record
 * feed for a model type (catalog mode); the search payload drops the key,
 * which the BE treats as the cross-record signal.
 * @param {string} modelType - Record type (e.g. `'Entity'`, `'AfeHeader'`).
 * @param {number} [modelId] - Specific record id. Omit for cross-record mode.
 * @return {{ searchAtom: Atom, resetSearchDataAtom: Atom }} Memoized atom pair.
 */
export const useActivityFeedAtom = (modelType: string, modelId?: number) => {
  return useMemo(() => {
    return searchAtomPair<ActivityFeedItem, ActivityFeedSearchParams>(
      { href: '/queries/activity_feeds' },
      {
        modelType,
        modelId,
        page: 1,
        pageSize: 25,
        sortAttribute: 'created_at',
        sortDirection: 'DESC',
      }
    );
  }, [modelType, modelId]);
};
